function setCaretAtTheBeginning(elem) {
    if (!elem) {
        return;
    }

    elem.focus();
    elem.scrollTop = 0;
    elem.setSelectionRange(0, 0);

}

export default setCaretAtTheBeginning;